const heroArt =
  'https://readdy.ai/api/search-image?query=Glossy%203D%20mascot%20of%20a%20cheerful%20watermelon%20slice%20wearing%20a%20tiny%20golden%20crown%20and%20holding%20a%20mini%20ballot%20box%2C%20warm%20coral%20amber%20and%20fresh%20green%20palette%2C%20soft%20cream%20background%2C%20playful%20voting%20energy%2C%20studio%20lighting%2C%20high%20detail%2C%20editorial%203D%20render&width=1000&height=940&seq=hero-melon&orientation=squarish';

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      {/* decorative soft blobs */}
      <div aria-hidden className="pointer-events-none absolute inset-0">
        <div className="absolute -left-24 top-10 h-72 w-72 rounded-full bg-primary-200/40 blur-3xl" />
        <div className="absolute right-0 top-40 h-80 w-80 rounded-full bg-accent-200/40 blur-3xl" />
        <div className="absolute bottom-0 left-1/3 h-64 w-64 rounded-full bg-secondary-200/40 blur-3xl" />
      </div>

      <div className="relative mx-auto grid w-full max-w-7xl grid-cols-1 items-center gap-8 px-4 pb-12 pt-10 md:px-6 lg:grid-cols-[1.05fr_0.95fr] lg:gap-6 lg:px-10 lg:pb-20 lg:pt-16">
        {/* Copy */}
        <div className="relative z-10 w-full">
          <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-background-300 bg-background-100/80 px-3 py-1.5 text-xs font-medium text-foreground-700">
            <span className="relative flex h-2 w-2">
              <span className="animate-pulse-dot absolute inline-flex h-full w-full rounded-full bg-primary-500" />
            </span>
            <span className="whitespace-nowrap">全网吃瓜第一现场 · 实时更新</span>
            <span className="whitespace-nowrap font-bold text-primary-600">460+ 热门话题</span>
          </div>

          <h1 className="font-display text-4xl leading-tight text-foreground-950 md:text-5xl lg:text-[3.4rem]">
            今天，你的一票
            <br />
            让谁登顶<span className="text-primary-600">吃瓜榜</span>？
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            从综艺名场面到网红塌房，从萌宠顶流到离谱投票——吃瓜榜单把全网最好笑的瓜都搬上投票台。
            <span className="font-semibold text-foreground-800">你的每次选择，都在改写实时排名。</span>
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#hotlist"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-all hover:bg-primary-600 hover:shadow-none"
            >
              <i className="ri-fire-fill text-lg leading-none" />
              立即去投票
            </a>
            <a
              href="#pk"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-100/70 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-secondary-300 hover:bg-secondary-100"
            >
              <i className="ri-vip-crown-line text-lg leading-none text-secondary-600" />
              围观人气PK
            </a>
          </div>

          {/* live mini stats */}
          <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3">
            <div className="flex items-center gap-2 text-sm text-foreground-600">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                <i className="ri-user-heart-line text-lg leading-none" />
              </span>
              <span>
                <b className="block text-base text-foreground-950">3120万+</b>
                网友已参与
              </span>
            </div>
            <div className="flex items-center gap-2 text-sm text-foreground-600">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                <i className="ri-vip-diamond-line text-lg leading-none" />
              </span>
              <span>
                <b className="block text-base text-foreground-950">2.18亿+</b>
                累计有效票数
              </span>
            </div>
          </div>
        </div>

        {/* Art side */}
        <div className="relative z-10 mx-auto w-full max-w-md lg:max-w-none">
          <div className="relative">
            <img
              src={heroArt}
              alt="吃瓜榜单卡通西瓜吉祥物手举投票箱的插画"
              title="吃瓜榜单 · 网友票选人气PK"
              className="aspect-square w-full rounded-[2rem] border border-background-200 object-cover"
            />

            {/* floating top-right vote chip */}
            <div className="animate-floaty absolute -right-3 -top-3 rounded-2xl border border-background-200 bg-background-100 px-4 py-3 shadow-none md:-right-6" style={{ ['--float-rot' as string]: '3deg' }}>
              <p className="flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-time-line text-sm leading-none text-secondary-600" />
                正在实时投票
              </p>
              <p className="mt-1 text-sm font-bold text-foreground-950">
                年度名场面 <span className="text-primary-600">+12.6万</span>
              </p>
            </div>

            {/* floating bottom-left ranking chip */}
            <div className="animate-floaty absolute -bottom-4 -left-3 rounded-2xl border border-background-200 bg-background-100 px-4 py-3 md:-left-6" style={{ ['--float-rot' as string]: '-3deg', animationDelay: '1.2s' }}>
              <p className="flex items-center gap-1.5 text-xs text-foreground-500">
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-accent-500 text-[10px] font-bold text-background-50">1</span>
                实时热榜榜首
              </p>
              <p className="mt-1.5 flex items-center gap-2 text-sm font-bold text-foreground-950">
                <i className="ri-fire-fill text-lg leading-none text-primary-500" />
                38.6万票
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}